import React from "react";
import { useTranslation } from "react-i18next";
import CommonDialog from "../../../../../common/components/dialog/CommonDialog";
import { MeterForm } from "../meter-form";
import { BulkLineItem } from "../../../../../model/bulk-purchase/bulk-purchase-customer";
import styles from "./add-edit-meter-modal.module.scss";

interface AddEditMeterModalProps {
	item: BulkLineItem;
	onSave: (item: BulkLineItem) => void;
	onClose: () => void;
	currency?: string;
}

/** Bottom-sheet/modal for editing an existing bulk line item. */
export const AddEditMeterModal: React.FC<AddEditMeterModalProps> = ({ item, onSave, onClose, currency }) => {
	const { t } = useTranslation();
	return (
		<CommonDialog onCloseDialog={onClose} bottomSheetOnMobile borderRadius="20px">
			<div className={styles.wrapper}>
				<h2 className={styles.title}>{t("buyElectricity.bulk.editDetails")}</h2>
				<MeterForm
					initialItem={item}
					submitLabel={t("buyElectricity.bulk.save")}
					onSubmit={onSave}
					onCancel={onClose}
					currency={currency}
				/>
			</div>
		</CommonDialog>
	);
};

export default AddEditMeterModal;
